import * as React from "react";

import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";

export function ScopeColumnMenu(props: GridColumnMenuProps) {
  const data = [{ InScope: "In Scope" }, { InScope: "Out of Scope" }];

  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      {...props}
      data={data}
      searchBox={() => null}
    />
  );
}
